import React from 'react';
import logoBlue from '../../assets/svgs/logo--blue.svg';
import {
  Card,
  PaddedBox,
  Image,
  FlexContainer
} from 'src/components/base/container';
import { observer } from 'mobx-react-lite';
import RegisterAccountForm from './RegisterAccountForm';
import { PageTitle } from 'src/components/base/styledComponents';
import { Box, LogoBox, ImageBox, RegisterFormBox } from './styledComponents';


const CreateAccount: React.FC = () => {

  return (
    <FlexContainer justifyContent={'center'}>
      <Box>
        <Card>
          <PaddedBox>
            <FlexContainer column alignItems={'center'}>
              <LogoBox>
                <ImageBox>
                  <Image height={'100%'} width={'100%'} src={logoBlue} alt='logo' />
                </ImageBox>
              </LogoBox>
              <PageTitle>Create Your Account</PageTitle>
              <RegisterFormBox>
                <RegisterAccountForm />
              </RegisterFormBox>
            </FlexContainer>
          </PaddedBox>
        </Card>
      </Box>
    </FlexContainer>
  );
}

export default observer(CreateAccount);
